/**
 * Enums das abas dos formulários de Serviços (conjuntos fechados de UI).
 * Centraliza o que antes eram uniões de literais duplicadas em cada componente.
 */

/** Abas do formulário Pré-Médico (PF). */
export enum EAbaPreMedico {
    DADOS = 'DADOS',
    DOC = 'DOC',
    CORR = 'CORR',
    TEL = 'TEL',
    FORM = 'FORM',
    DEF = 'DEF',
    ANEXOS = 'ANEXOS',
    REVISAO = 'REVISAO'
}

/** Abas do formulário de Consultório Privado (PF). */
export enum EAbaConsultorioPrivado {
    DADOS = 'DADOS',
    ENDERECO = 'ENDERECO',
    COMP = 'COMP',
    ESP = 'ESP',
    HORA = 'HORA'
}

/** Abas do formulário Pré-Prestador (PJ). */
export enum EAbaPrePrestador {
    DADOS = 'DADOS',
    FUNC = 'FUNC',
    DOC = 'DOC',
    SOCIETARIO = 'SOCIETARIO',
    CLINICO = 'CLINICO',
    ESPECIALIDADES = 'ESPECIALIDADES',
    AREA_ATUACAO = 'AREA_ATUACAO',
    SERVICOS = 'SERVICOS',
    ATIVIDADES = 'ATIVIDADES',
    REC_MATERIAIS = 'REC_MATERIAIS',
    REC_HUMANOS = 'REC_HUMANOS',
    PENDENTE = 'PENDENTE',
    DESCONTOS = 'DESCONTOS',
    ANEXOS = 'ANEXOS'
}
